unable to read source [project]/node_modules/src/camera/permissions.ts